import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import "./Inventory.css";
import { getSamrtProducts } from "../../services/api/ProductAPI";

class OfferSmartProducts extends Component {
  constructor() {
    super();
    this.state = {
      products: [],
      searchText: "",
      activePage: 1,
      itemsCountPerPage: 12,
      totalItemsCount: 0,
      recordFrom: 0,
      paginationStatus: "No records to display",
      loading: false,
      selectedProducts: [],
      viewMode: "grid" // 'grid' or 'table'
    };
    
    this.handleSearch = this.handleSearch.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.toggleProductSelection = this.toggleProductSelection.bind(this);
    this.handlePrint = this.handlePrint.bind(this);
    this.toggleViewMode = this.toggleViewMode.bind(this);
    this.toggleSelectAll = this.toggleSelectAll.bind(this);
    this.showPaginationStatus = this.showPaginationStatus.bind(this);
  }

  componentDidMount() {
    this.loadProducts(this.state.searchText, this.state.recordFrom, this.state.itemsCountPerPage);
  }

  loadProducts(searchText = "", from, size) {
    this.setState({ loading: true });
    
    getSamrtProducts(
      this.props.registration.registration.key,
      from,
      size,
      searchText
    ).then((res) => {
      console.log("res", res);
      if (res.code == 0) {
        // Transform API data to match our expected format
        const transformedProducts = res.searchResult.map(product => ({
          id: product.key || product.SKU,
          name: product.Name || "Unnamed Product",
          sku: product.SKU || "N/A",
        //image: product.Image,
           image: (product.Images && product.Images.length > 0) ? product.Images[0]["ImagePath"] : "",
          mrp: parseFloat(product.MRP) || 0,
          discountPercentage: parseFloat(product.DiscountPercentage) || 0,
          sellingPrice: parseFloat(product.RetailPrice) || 0,
          // Additional fields from API if needed
          brand: product.Brand,
          category: product.Category
        }));
        
        this.setState({
          products: transformedProducts,
          totalItemsCount: res.totalItemsCount,
          loading: false
        }, () => {
          this.showPaginationStatus();
        });
      } else {
        this.setState({
          products: [],
          totalItemsCount: 0,
          loading: false
        }, () => {
          this.showPaginationStatus();
        });
      }
    }).catch(error => {
      console.error("Error loading products:", error);
      this.setState({
        products: [],
        totalItemsCount: 0,
        loading: false
      }, () => {
        this.showPaginationStatus();
      });
    });
  }

  handleSearch() {
    this.setState({ activePage: 1, recordFrom: 0 }, () => {
      this.loadProducts(this.state.searchText, 0, this.state.itemsCountPerPage);
    });
  }

  handlePageChange(pageNumber) {
    let recordFrom = (pageNumber - 1) * this.state.itemsCountPerPage;
    this.setState({ activePage: pageNumber, recordFrom: recordFrom }, () => {
      this.loadProducts(this.state.searchText, recordFrom, this.state.itemsCountPerPage);
    });
  }

  showPaginationStatus() {
    let paginationStatus;
    if (this.state.totalItemsCount === 0) {
      paginationStatus = "No records to display";
    } else if (this.state.recordFrom + 1 === this.state.totalItemsCount) {
      paginationStatus =
        "Showing " +
        this.state.totalItemsCount +
        " of " +
        this.state.totalItemsCount;
    } else if (
      this.state.recordFrom + this.state.itemsCountPerPage + 1 >
      this.state.totalItemsCount
    ) {
      paginationStatus =
        "Showing " +
        (this.state.recordFrom + 1) +
        " to  " +
        this.state.totalItemsCount +
        " of " +
        this.state.totalItemsCount;
    } else {
      paginationStatus =
        "Showing " +
        (this.state.recordFrom + 1) +
        " to  " +
        (this.state.recordFrom + this.state.itemsCountPerPage) +
        " of " +
        this.state.totalItemsCount;
    }
    this.setState({ paginationStatus: paginationStatus });
  }

  toggleProductSelection(productId) {
    this.setState(prevState => {
      const selectedProducts = [...prevState.selectedProducts];
      const index = selectedProducts.indexOf(productId);
      
      if (index > -1) {
        selectedProducts.splice(index, 1);
      } else {
        selectedProducts.push(productId);
      }
      
      return { selectedProducts };
    });
  }

  toggleSelectAll() {
    if (this.state.selectedProducts.length === this.state.products.length) {
      this.setState({ selectedProducts: [] });
    } else {
      const allProductIds = this.state.products.map(product => product.id);
      this.setState({ selectedProducts: allProductIds });
    }
  }

  toggleViewMode() {
    this.setState(prevState => ({
      viewMode: prevState.viewMode === "grid" ? "table" : "grid"
    }));
  }

  // handlePrintbk() {
  //   if (this.state.selectedProducts.length === 0) {
  //     alert("Please select at least one product to print");
  //     return;
  //   }

  //   const selectedProductsData = this.state.products.filter(product => 
  //     this.state.selectedProducts.includes(product.id)
  //   );

  //   // Format for 5x4 inch cards (approximately 3.5x2 inches per card with 2 columns)
  //   const printContent = `
  //     <html>
  //       <head>
  //         <title>Offer Printout</title>
  //         <style>
  //           @media print {
  //             @page {
  //               size: 5in 4in;
  //               margin: 0.1in;
  //             }
  //             body {
  //               margin: 0;
  //               padding: 0;
  //               font-family: Arial, sans-serif;
  //               font-size: 10px;
  //             }
  //             .card-container {
  //               display: grid;
  //               grid-template-columns: repeat(2, 1.7in);
  //               grid-gap: 0.1in;
  //               width: 100%;
  //               height: 100%;
  //             }
  //             .card {
  //               width: 1.7in;
  //               height: 2in;
  //               border: 1px solid #ddd;
  //               padding: 0.1in;
  //               box-sizing: border-box;
  //               page-break-inside: avoid;
  //             }
  //             .product-name {
  //               font-weight: bold;
  //               font-size: 11px;
  //               text-align: center;
  //               margin-bottom: 0.05in;
  //             }
  //             .product-image {
  //               width: 0.8in;
  //               height: 0.8in;
  //               display: block;
  //               margin: 0 auto;
  //               object-fit: contain;
  //             }
  //             .product-details {
  //               margin-top: 0.05in;
  //             }
  //             .price-details {
  //               display: flex;
  //               justify-content: space-between;
  //               margin: 0.03in 0;
  //             }
  //             .discount-badge {
  //               background-color: #ff4444;
  //               color: white;
  //               padding: 2px 4px;
  //               border-radius: 2px;
  //               font-size: 9px;
  //               font-weight: bold;
  //             }
  //             .mrp {
  //               text-decoration: line-through;
  //               color: #888;
  //             }
  //             .selling-price {
  //               font-weight: bold;
  //               color: #ff4444;
  //             }
  //             .save-amount {
  //               color: #008000;
  //             }
  //           }
  //         </style>
  //       </head>
  //       <body>
  //         <div class="card-container">
  //           ${selectedProductsData.map(product => `
  //             <div class="card">
  //               <div class="product-name">${product.name}</div>
  //               ${product.image ? `<img class="product-image" src="${product.image}" alt="${product.name}" onerror="this.style.display='none'">` : ''}
  //               <div class="product-details">
  //                 <div class="price-details">
  //                   <span class="mrp">₹${product.mrp.toFixed(2)}</span>
  //                   <span class="discount-badge">${product.discountPercentage}% OFF</span>
  //                 </div>
  //                 <div class="price-details">
  //                   <span>Now:</span>
  //                   <span class="selling-price">₹${product.sellingPrice.toFixed(2)}</span>
  //                 </div>
  //                 <div class="price-details">
  //                   <span>Save:</span>
  //                   <span class="save-amount">₹${(product.mrp - product.sellingPrice).toFixed(2)}</span>
  //                 </div>
  //                 <div class="price-details">
  //                   <span>SKU:</span>
  //                   <span>${product.sku}</span>
  //                 </div>
  //               </div>
  //             </div>
  //           `).join('')}
  //         </div>
  //       </body>
  //     </html>
  //   `;

  //   const printWindow = window.open('', '_blank');
  //   printWindow.document.write(printContent);
  //   printWindow.document.close();
  //   printWindow.focus();
    
  //   setTimeout(() => {
  //     printWindow.print();
  //     printWindow.close();
  //   }, 250);
  // }

handlePrint() {
  if (this.state.selectedProducts.length === 0) {
    alert("Please select at least one product to print");
    return;
  }

  const selectedProductsData = this.state.products.filter(product => 
    this.state.selectedProducts.includes(product.id)
  );

  const printContent = `
    <html>
      <head>
        <title>Special Offers</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            font-size: 12px;
            margin: 0;
            padding: 0.1in;
          }
          .page {
            width: 5in;
            height: 4in;
            page-break-after: always;
          }
          .card-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
          }
          .card {
            width: 48%;
            border: 1px solid #ccc;
            padding: 5px;
            margin-bottom: 5px;
            box-sizing: border-box;
          }
          .product-name {
            font-weight: bold;
            text-align: center;
            margin-bottom: 5px;
            font-size: 11px;
          }
          .price-info {
            display: flex;
            justify-content: space-between;
            margin: 2px 0;
          }
          .discount {
            background: #ff4444;
            color: white;
            padding: 2px 4px;
            border-radius: 3px;
            font-size: 10px;
          }
          .mrp {
            text-decoration: line-through;
            color: #888;
          }
          .selling-price {
            font-weight: bold;
            color: #d00;
          }
          @media print {
            body {
              margin: 0;
              padding: 0.1in;
            }
          }
        </style>
      </head>
      <body>
        <div class="page">
          <div class="card-container">
            ${selectedProductsData.map(product => `
              <div class="card">
                <div class="product-name">${product.name}</div>
                <div class="price-info">
                  <span class="mrp">₹${product.mrp.toFixed(2)}</span>
                  <span class="discount">${product.discountPercentage}% OFF</span>
                </div>
                <div class="price-info">
                  <span>Price: </span>
                  <span class="selling-price">₹${product.sellingPrice.toFixed(2)}</span>
                </div>
                <div class="price-info">
                  <span>Save: </span>
                  <span>₹${(product.mrp - product.sellingPrice).toFixed(2)}</span>
                </div>
                <div class="price-info">
                  <span>SKU: </span>
                  <span>${product.sku}</span>
                </div>
              </div>
            `).join('')}
          </div>
        </div>
        <script>
          window.onload = function() {
            window.print();
            setTimeout(function() {
              window.close();
            }, 100);
          };
        </script>
      </body>
    </html>
  `;

  const printWindow = window.open('', '_blank');
  if (printWindow) {
    printWindow.document.write(printContent);
    printWindow.document.close();
  } else {
    alert('Please allow popups for this site to print');
  }
}

  renderGridViewbk() {
    return (
      <div className="row" style={{ marginTop: "20px" }}>
        {this.state.products.map(product => (
          <div key={product.id} className="col-md-4 col-sm-6 col-xs-12">
            <div className="box box-widget widget-user-2">
              <div className="widget-user-header" style={{ padding: "0px" }}>
                <div className="widget-user-image">
                  <img 
                    className="img-circle" 
                    src={product.image} 
                    alt={product.name}
                    style={{ width: "60px", height: "60px", objectFit: "cover" }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
                <h5 className="widget-user-username">{product.name}</h5>
                <h6 className="widget-user-desc">SKU: {product.sku}</h6>
              </div>
              <div className="box-footer no-padding">
                <ul className="nav nav-stacked">
                  <li>
                    MRP: 
                    <span className="pull-right" style={{ textDecoration: "line-through" }}>
                      ₹{product.mrp.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    Discount: 
                    <span className="pull-right badge bg-red">
                      {product.discountPercentage}% OFF
                    </span>
                  </li>
                  <li>
                    Selling Price: 
                    <span className="pull-right text-bold text-green">
                      ₹{product.sellingPrice.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    You Save: 
                    <span className="pull-right">
                      ₹{(product.mrp - product.sellingPrice).toFixed(2)}
                    </span>
                  </li>
                  <li style={{ padding: "10px" }}>
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={this.state.selectedProducts.includes(product.id)}
                          onChange={() => this.toggleProductSelection(product.id)}
                        />
                        Select for Print
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderGridViewbkk() {
  return (
    <div className="row" style={{ marginTop: "20px", marginLeft: "-5px", marginRight: "-5px" }}>
      {this.state.products.map(product => (
        <div key={product.id} className="col-md-4 col-sm-6 col-xs-12" style={{ padding: "5px" }}>
          <div className="box box-widget widget-user-2" style={{ height: "100%" }}>
                        <div className="widget-user-header" style={{ padding: "0px" }}>
                <div className="widget-user-image">
                  <img 
                    className="img-circle" 
                    src={product.image} 
                    alt={product.name}
                    style={{ width: "60px", height: "60px", objectFit: "cover" }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
                <h5 className="widget-user-username">{product.name}</h5>
                <h6 className="widget-user-desc">SKU: {product.sku}</h6>
              </div>
              <div className="box-footer no-padding">
                <ul className="nav nav-stacked">
                  <li>
                    MRP: 
                    <span className="pull-right" style={{ textDecoration: "line-through" }}>
                      ₹{product.mrp.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    Discount: 
                    <span className="pull-right badge bg-red">
                      {product.discountPercentage}% OFF
                    </span>
                  </li>
                  <li>
                    Selling Price: 
                    <span className="pull-right text-bold text-green">
                      ₹{product.sellingPrice.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    You Save: 
                    <span className="pull-right">
                      ₹{(product.mrp - product.sellingPrice).toFixed(2)}
                    </span>
                  </li>
                  <li style={{ padding: "10px" }}>
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={this.state.selectedProducts.includes(product.id)}
                          onChange={() => this.toggleProductSelection(product.id)}
                        />
                        Select for Print
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
          </div>
        </div>
      ))}
      {/* Add empty divs to maintain grid alignment */}
      {this.state.products.length % 3 !== 0 && 
        Array.from({ length: 3 - (this.state.products.length % 3) }).map((_, index) => (
          <div key={`empty-${index}`} className="col-md-4 col-sm-6 col-xs-12" style={{ padding: "5px", visibility: "hidden" }}>
            <div className="box box-widget widget-user-2" style={{ height: "100%", border: "none" }}></div>
          </div>
        ))
      }
    </div>
  );
  }

renderGridView() {
    return (
      <div className="products-grid-container" style={{ marginTop: "20px" }}>
        {this.state.products.map(product => (
          <div key={product.id} className="product-card">
            <div className="box box-widget widget-user-2">
              <div className="widget-user-header" style={{ padding: "0px" }}>
                <div className="widget-user-image">
                  <img 
                    className="img-circle" 
                    src={product.image} 
                    alt={product.name}
                    style={{ width: "60px", height: "60px", objectFit: "cover" }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </div>
                <h5 className="widget-user-username">{product.name}</h5>
                <h6 className="widget-user-desc">SKU: {product.sku}</h6>
              </div>
              <div className="box-footer no-padding">
                <ul className="nav nav-stacked">
                  <li>
                    MRP: 
                    <span className="pull-right" style={{ textDecoration: "line-through" }}>
                      ₹{product.mrp.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    Discount: 
                    <span className="pull-right badge bg-red">
                      {product.discountPercentage}% OFF
                    </span>
                  </li>
                  <li>
                    Selling Price: 
                    <span className="pull-right text-bold text-green">
                      ₹{product.sellingPrice.toFixed(2)}
                    </span>
                  </li>
                  <li>
                    You Save: 
                    <span className="pull-right">
                      ₹{(product.mrp - product.sellingPrice).toFixed(2)}
                    </span>
                  </li>
                  <li style={{ padding: "10px" }}>
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          checked={this.state.selectedProducts.includes(product.id)}
                          onChange={() => this.toggleProductSelection(product.id)}
                        />
                        Select for Print
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderTableView() {
    return (
      <div className="table-responsive" style={{ marginTop: "20px" }}>
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={this.state.selectedProducts.length === this.state.products.length && this.state.products.length > 0}
                  onChange={this.toggleSelectAll}
                />
              </th>
              <th>Image</th>
              <th>Product Name</th>
              <th>SKU</th>
              <th>MRP</th>
              <th>Discount</th>
              <th>Selling Price</th>
              <th>You Save</th>
            </tr>
          </thead>
          <tbody>
            {this.state.products.map(product => (
              <tr key={product.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={this.state.selectedProducts.includes(product.id)}
                    onChange={() => this.toggleProductSelection(product.id)}
                  />
                </td>
                <td>
                  <img 
                    src={product.image} 
                    alt={product.name}
                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                    onError={(e) => {
                      e.target.style.display = 'none';
                    }}
                  />
                </td>
                <td>{product.name}</td>
                <td>{product.sku}</td>
                <td style={{ textDecoration: "line-through" }}>₹{product.mrp.toFixed(2)}</td>
                <td>
                  <span className="badge bg-red">
                    {product.discountPercentage}% OFF
                  </span>
                </td>
                <td className="text-bold text-green">₹{product.sellingPrice.toFixed(2)}</td>
                <td className="text-green">₹{(product.mrp - product.sellingPrice).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    return (
      <div className="content-wrapper">
        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box">
                <div className="box-header with-border">
                  <div className="row">
                    <div className="col-md-6 col-xs-9">
                      <font style={{ fontSize: "30px" }}>Smart Products Offers</font>
                    </div>
                    <div className="col-md-6 col-xs-3">
                      <button
                        type="cancel"
                        className="btn btn-default pull-right btn-flat"
                        style={{ marginTop: "5px", marginLeft: "10px" }}
                        onClick={() => this.props.history.push("/home")}
                      >
                        <i className="fa fa-arrow-left"></i> Back
                      </button>
                    </div>
                  </div>
                </div>
                <div className="box-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Search by Product Name or SKU</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control input-md"
                            value={this.state.searchText}
                            onChange={(evt) => this.setState({ searchText: evt.target.value })}
                            onKeyPress={(e) => e.key === 'Enter' && this.handleSearch()}
                            placeholder="Enter product name or SKU"
                          />
                          <span className="input-group-btn">
                            <button
                              type="button"
                              className="btn btn-primary btn-flat"
                              onClick={this.handleSearch}
                            >
                              Search
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 text-center">
                      <div className="form-group">
                        <label>View Mode</label>
                        <div>
                          <button
                            className="btn btn-default btn-flat"
                            onClick={this.toggleViewMode}
                            style={{ marginTop: "0px" }}
                          >
                            <i className={`fa fa-${this.state.viewMode === "grid" ? "th" : "table"}`}></i> 
                            Switch to {this.state.viewMode === "grid" ? "Table" : "Grid"} View
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4 text-right">
                      <button
                        className="btn btn-success btn-flat"
                        style={{ marginTop: "25px" }}
                        onClick={this.handlePrint}
                        disabled={this.state.selectedProducts.length === 0}
                      >
                        <i className="fa fa-print"></i> Print Selected ({this.state.selectedProducts.length})
                      </button>
                    </div>
                  </div>

                  {this.state.loading ? (
                    <div className="text-center">
                      <i className="fa fa-spinner fa-spin"></i> Loading products...
                    </div>
                  ) : (
                    <>
                      {this.state.viewMode === "grid" ? this.renderGridView() : this.renderTableView()}

                      {this.state.totalItemsCount === 0 && (
                        <div className="alert alert-info text-center">
                          No products found matching your search criteria.
                        </div>
                      )}

                      {this.state.totalItemsCount > 0 && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="pull-left" style={{ marginTop: "25px" }}>
                              {this.state.paginationStatus}
                            </div>
                            <div className="pull-right">
                              <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsCountPerPage}
                                totalItemsCount={this.state.totalItemsCount}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange}
                                itemClass="page-item"
                                linkClass="page-link"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(OfferSmartProducts);


// import React, { Component } from "react";
// import { withRouter } from "react-router-dom";
// import Pagination from "react-js-pagination";
// import "./Inventory.css";
// class OfferSmartProducts extends Component {
//   constructor() {
//     super();
//     this.state = {
//       products: [],
//       searchText: "",
//       activePage: 1,
//       itemsCountPerPage: 12,
//       totalItemsCount: 0,
//       loading: false,
//       selectedProducts: []
//     };
    
//     this.handleSearch = this.handleSearch.bind(this);
//     this.handlePageChange = this.handlePageChange.bind(this);
//     this.toggleProductSelection = this.toggleProductSelection.bind(this);
//     this.handlePrint = this.handlePrint.bind(this);
//   }

//   componentDidMount() {
//     // Load static product data
//     this.loadProducts();
//   }

//   loadProducts() {
//     // Static product data with discount information
//     const staticProducts = [
//       {
//         id: 1,
//         name: "Wireless Headphones",
//         sku: "WH-1000XM4",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/rSPfDpkBsQk_wCKXsrpz",
//         mrp: 299.99,
//         discountPercentage: 25,
//         sellingPrice: 224.99
//       },
//       {
//         id: 2,
//         name: "Smart Watch",
//         sku: "SW-GT3",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/bwpKFI8BwftCFr8T6Eld",
//         mrp: 199.99,
//         discountPercentage: 15,
//         sellingPrice: 169.99
//       },
//       {
//         id: 3,
//         name: "Bluetooth Speaker",
//         sku: "BS-X100",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/w5NohpYB7iNa1qjfYz9i",
//         mrp: 129.99,
//         discountPercentage: 30,
//         sellingPrice: 90.99
//       },
//       {
//         id: 4,
//         name: "Gaming Mouse",
//         sku: "GM-RGB",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/VIwvtJIBFI3wVe-xD9Nz",
//         mrp: 79.99,
//         discountPercentage: 20,
//         sellingPrice: 63.99
//       },
//       {
//         id: 5,
//         name: "Mechanical Keyboard",
//         sku: "MK-BLUE",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/wkgvtJIBYsAi_E-FBaFa",
//         mrp: 119.99,
//         discountPercentage: 10,
//         sellingPrice: 107.99
//       },
//       {
//         id: 6,
//         name: "USB-C Hub",
//         sku: "UCH-7IN1",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/wkgvtJIBYsAi_E-FBaFa",
//         mrp: 89.99,
//         discountPercentage: 35,
//         sellingPrice: 58.49
//       },
//       {
//         id: 7,
//         name: "Wireless Charger",
//         sku: "WC-15W",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/wkgvtJIBYsAi_E-FBaFa",
//         mrp: 49.99,
//         discountPercentage: 40,
//         sellingPrice: 29.99
//       },
//       {
//         id: 8,
//         name: "Laptop Sleeve",
//         sku: "LS-15IN",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/wkgvtJIBYsAi_E-FBaFa",
//         mrp: 39.99,
//         discountPercentage: 25,
//         sellingPrice: 29.99
//       },
//       {
//         id: 9,
//         name: "Phone Case",
//         sku: "PC-IP13",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/wkgvtJIBYsAi_E-FBaFa",
//         mrp: 29.99,
//         discountPercentage: 50,
//         sellingPrice: 14.99
//       },
//       {
//         id: 10,
//         name: "Power Bank",
//         sku: "PB-10000",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/r98mJZYBD8EitppGs8Ji",
//         mrp: 59.99,
//         discountPercentage: 20,
//         sellingPrice: 47.99
//       },
//       {
//         id: 11,
//         name: "Wireless Earbuds",
//         sku: "WE-TWS",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/r98mJZYBD8EitppGs8Ji",
//         mrp: 129.99,
//         discountPercentage: 30,
//         sellingPrice: 90.99
//       },
//       {
//         id: 12,
//         name: "Monitor Stand",
//         sku: "MS-ADJ",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/r98mJZYBD8EitppGs8Ji",
//         mrp: 69.99,
//         discountPercentage: 15,
//         sellingPrice: 59.49
//       },
//       {
//         id: 13,
//         name: "Desk Lamp",
//         sku: "DL-LED",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/r98mJZYBD8EitppGs8Ji",
//         mrp: 49.99,
//         discountPercentage: 25,
//         sellingPrice: 37.49
//       },
//       {
//         id: 14,
//         name: "Webcam",
//         sku: "WC-1080P",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/r98mJZYBD8EitppGs8Ji",
//         mrp: 89.99,
//         discountPercentage: 20,
//         sellingPrice: 71.99
//       },
//       {
//         id: 15,
//         name: "External SSD",
//         sku: "ESSD-500GB",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/txccK4oBeSo_FOtc92Ms",
//         mrp: 129.99,
//         discountPercentage: 10,
//         sellingPrice: 116.99
//       },
//       {
//         id: 16,
//         name: "Noise Cancelling Earbuds",
//         sku: "NCE-BT",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/URP0hpUBJGOu73NpfZwU",
//         mrp: 179.99,
//         discountPercentage: 35,
//         sellingPrice: 116.99
//       },
//       {
//         id: 17,
//         name: "Ergonomic Chair",
//         sku: "EC-400",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/rKaxoJYB6CUYWru4b7yb",
//         mrp: 299.99,
//         discountPercentage: 15,
//         sellingPrice: 254.99
//       },
//       {
//         id: 18,
//         name: "Standing Desk",
//         sku: "SD-ELEV",
//         image: "https://docs.phonepe.com/cdn-cgi/image/width={width},height={height}/public/rKaxoJYB6CUYWru4b7yb",
//         mrp: 499.99,
//         discountPercentage: 20,
//         sellingPrice: 399.99
//       }
//     ];

//     // Filter products based on search text if any
//     let filteredProducts = staticProducts;
//     if (this.state.searchText) {
//       filteredProducts = staticProducts.filter(product => 
//         product.name.toLowerCase().includes(this.state.searchText.toLowerCase()) ||
//         product.sku.toLowerCase().includes(this.state.searchText.toLowerCase())
//       );
//     }

//     this.setState({
//       products: filteredProducts,
//       totalItemsCount: filteredProducts.length
//     });
//   }

//   handleSearch() {
//     this.setState({ activePage: 1 }, () => {
//       this.loadProducts();
//     });
//   }

//   handlePageChange(pageNumber) {
//     this.setState({ activePage: pageNumber });
//   }

//   toggleProductSelection(productId) {
//     this.setState(prevState => {
//       const selectedProducts = [...prevState.selectedProducts];
//       const index = selectedProducts.indexOf(productId);
      
//       if (index > -1) {
//         selectedProducts.splice(index, 1);
//       } else {
//         selectedProducts.push(productId);
//       }
      
//       return { selectedProducts };
//     });
//   }

//   handlePrint() {
//     if (this.state.selectedProducts.length === 0) {
//       alert("Please select at least one product to print");
//       return;
//     }

//     // Prepare data for printing
//     const selectedProductsData = this.state.products.filter(product => 
//       this.state.selectedProducts.includes(product.id)
//     );

//     // Format the print content
//     const printContent = `
//       <html>
//         <head>
//           <title>Offer Printout</title>
//           <style>
//             body { font-family: Arial, sans-serif; margin: 20px; }
//             .header { text-align: center; margin-bottom: 20px; }
//             .product { margin-bottom: 15px; padding: 10px; border-bottom: 1px solid #eee; }
//             .product-name { font-weight: bold; font-size: 16px; }
//             .product-details { display: flex; justify-content: space-between; }
//             .discount-badge { 
//               background-color: #ff4444; 
//               color: white; 
//               padding: 3px 8px; 
//               border-radius: 3px; 
//               font-weight: bold;
//             }
//           </style>
//         </head>
//         <body>
//           <div class="header">
//             <h1>Special Offers</h1>
//             <p>Generated on: ${new Date().toLocaleDateString()}</p>
//           </div>
//           ${selectedProductsData.map(product => `
//             <div class="product">
//               <div class="product-name">${product.name} (${product.sku})</div>
//               <div class="product-details">
//                 <div>
//                   MRP: <span style="text-decoration: line-through;">₹${product.mrp.toFixed(2)}</span>
//                 </div>
//                 <div class="discount-badge">
//                   ${product.discountPercentage}% OFF
//                 </div>
//                 <div>
//                   Selling Price: <span style="font-weight: bold; color: #ff4444;">₹${product.sellingPrice.toFixed(2)}</span>
//                 </div>
//                 <div>
//                   You Save: ₹${(product.mrp - product.sellingPrice).toFixed(2)}
//                 </div>
//               </div>
//             </div>
//           `).join('')}
//         </body>
//       </html>
//     `;

//     // Open print window
//     const printWindow = window.open('', '_blank');
//     printWindow.document.write(printContent);
//     printWindow.document.close();
//     printWindow.focus();
    
//     // Wait for images to load before printing
//     setTimeout(() => {
//       printWindow.print();
//       printWindow.close();
//     }, 250);
//   }

//   render() {
//     // Calculate pagination
//     const indexOfLastItem = this.state.activePage * this.state.itemsCountPerPage;
//     const indexOfFirstItem = indexOfLastItem - this.state.itemsCountPerPage;
//     const currentItems = this.state.products.slice(indexOfFirstItem, indexOfLastItem);

//     return (
//       <div className="content-wrapper">
//         <section className="content">
//           <div className="row">
//             <div className="col-md-12">
//               <div className="box">
//                 <div className="box-header with-border">
//                   <div className="row">
//                     <div className="col-md-6 col-xs-9">
//                       <font style={{ fontSize: "30px" }}>Special Offers</font>
//                     </div>
//                     <div className="col-md-6 col-xs-3">
//                       <button
//                         type="cancel"
//                         className="btn btn-default pull-right btn-flat"
//                         style={{ marginTop: "5px", marginLeft: "10px" }}
//                         onClick={() => this.props.history.push("/home")}
//                       >
//                         <i className="fa fa-arrow-left"></i> Back
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//                 <div className="box-body">
//                   <div className="row">
//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <label>Search by Product Name or SKU</label>
//                         <div className="input-group">
//                           <input
//                             type="text"
//                             className="form-control input-md"
//                             value={this.state.searchText}
//                             onChange={(evt) => this.setState({ searchText: evt.target.value })}
//                             onKeyPress={(e) => e.key === 'Enter' && this.handleSearch()}
//                             placeholder="Enter product name or SKU"
//                           />
//                           <span className="input-group-btn">
//                             <button
//                               type="button"
//                               className="btn btn-primary btn-flat"
//                               onClick={this.handleSearch}
//                             >
//                               Search
//                             </button>
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-md-6 text-right">
//                       <button
//                         className="btn btn-success btn-flat"
//                         style={{ marginTop: "25px" }}
//                         onClick={this.handlePrint}
//                         disabled={this.state.selectedProducts.length === 0}
//                       >
//                         <i className="fa fa-print"></i> Print Selected ({this.state.selectedProducts.length})
//                       </button>
//                     </div>
//                   </div>

//                   <div className="row" style={{ marginTop: "20px" }}>
//                     {currentItems.map(product => (
//                       <div key={product.id} className="col-md-4 col-sm-6 col-xs-12">
//                         <div className="box box-widget widget-user-2">
//                           <div className="widget-user-header" style={{ padding: "0px" }}>
//                             <div className="widget-user-image">
//                               <img 
//                                 className="img-circle" 
//                                 src={product.image} 
//                                 alt={product.name}
//                                 style={{ width: "60px", height: "60px", objectFit: "cover" }}
//                               />
//                             </div>
//                             <h5 className="widget-user-username">{product.name}</h5>
//                             <h6 className="widget-user-desc">SKU: {product.sku}</h6>
//                           </div>
//                           <div className="box-footer no-padding">
//                             <ul className="nav nav-stacked">
//                               <li>
//                                 MRP: 
//                                 <span className="pull-right" style={{ textDecoration: "line-through" }}>
//                                   ₹{product.mrp.toFixed(2)}
//                                 </span>
//                               </li>
//                               <li>
//                                 Discount: 
//                                 <span className="pull-right badge bg-red">
//                                   {product.discountPercentage}% OFF
//                                 </span>
//                               </li>
//                               <li>
//                                 Selling Price: 
//                                 <span className="pull-right text-bold text-green">
//                                   ₹{product.sellingPrice.toFixed(2)}
//                                 </span>
//                               </li>
//                               <li>
//                                 You Save: 
//                                 <span className="pull-right">
//                                   ₹{(product.mrp - product.sellingPrice).toFixed(2)}
//                                 </span>
//                               </li>
//                               <li style={{ padding: "10px" }}>
//                                 <div className="checkbox">
//                                   <label>
//                                     <input
//                                       type="checkbox"
//                                       checked={this.state.selectedProducts.includes(product.id)}
//                                       onChange={() => this.toggleProductSelection(product.id)}
//                                     />
//                                     Select for Print
//                                   </label>
//                                 </div>
//                               </li>
//                             </ul>
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>

//                   {this.state.totalItemsCount === 0 && (
//                     <div className="alert alert-info text-center">
//                       No products found matching your search criteria.
//                     </div>
//                   )}

//                   {this.state.totalItemsCount > 0 && (
//                     <div className="row">
//                       <div className="col-md-12">
//                         <div className="pull-left" style={{ marginTop: "25px" }}>
//                           Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, this.state.totalItemsCount)} of {this.state.totalItemsCount} products
//                         </div>
//                         <div className="pull-right">
//                           <Pagination
//                             activePage={this.state.activePage}
//                             itemsCountPerPage={this.state.itemsCountPerPage}
//                             totalItemsCount={this.state.totalItemsCount}
//                             pageRangeDisplayed={5}
//                             onChange={this.handlePageChange}
//                             itemClass="page-item"
//                             linkClass="page-link"
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     );
//   }
// }

// export default withRouter(OfferSmartProducts);